export const en = {
  title: 'Content Modules',
}

export const es = en
